import styled from 'styled-components';

export const Wrapper = styled.footer`
  margin-top: 50px;
  background-color: #1f2532;
  height: 60px;
`;
